<!-- =========================================================================================
  File Name: SponsorEdit.vue
  Description: Sponsor Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-edit" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Edit Exhibitor</h3>
    </div>
    <vs-alert color="danger" title="Attendee Not Found" :active.sync="exhibitor_not_found">
      <span>Sponsor record with id: {{ $route.params.exhibitorId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="exhibitor_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs position="left" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab v-model="activeTab" label="Info" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <exhibitor-edit-tab-account :ContactAdmins="ContactAdmins" class="mt-4" :data="exhibitor_data" @activateTab="setActiveTab" />
            </div>
          </vs-tab>
          
          <vs-tab v-model="activeTab" label="Resources" icon-pack="feather" icon="icon-upload">
            <div class="tab-text">
              <exhibitor-resource class="mt-4" :data="exhibitor_data" @activateTab="setActiveTab" />
            </div>
          </vs-tab>

          <vs-tab v-model="activeTab" label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <exhibitor-edit-tab-social :data="exhibitor_data" />
            </div>
          </vs-tab>

          <vs-tab v-model="activeTab" label="Additional Info" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <exhibitor-additional-info :data="exhibitor_data" />
            </div>
          </vs-tab>

          
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ExhibitorEditTabAccount from "./ExhibitorEditTabAccount.vue";
import ExhibitorEditTabSocial from "./ExhibitorEditTabSocial.vue";
import ExhibitorResource from "./ExhibitorResource.vue";
import ExhibitorAdditionalInfo from "./ExhibitorAdditionalInfo.vue";

// Store Module
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";

export default {
  components: {
    ExhibitorEditTabAccount,
    ExhibitorEditTabSocial,
    ExhibitorResource,
    ExhibitorAdditionalInfo
  },
  data() {
    return {
      exhibitor_data: null,
      exhibitor_not_found: false,
      activeTab: 0,
      checkView: false,
      ContactAdmins: []
    };
  },
  watch: {
    activeTab() {
      this.fetch_exhibitor_data(this.$route.params.exhibitorId);
    }
  },
  methods: {
    setActiveTab(val){
      this.activeTab = val;
    },
    fetch_exhibitor_data(exhibitorId) {
      this.$store
        .dispatch("exhibitorManagement/fetchExhibitor", exhibitorId)
        .then(res => {
          this.exhibitor_data = res.data;
          this.exhibitor_data.ariealView = this.checkView
          for(let item of res.data.MappedContacts){
            if(item.IsAdmin)
              this.ContactAdmins.push(item.AttendeeId);
          }
        })
        .catch(err => {
        });
    },
    fetchExhibitorSettings(){
      this.$store.dispatch("exhibitorManagement/getSettings").then((res) => {
        if(res.AllowAerialView){
          this.checkView= true;
        }else{
          this.checkView = false;
        }
      
      });
    }
  },
  created() {
    //debugger;
    // Register Module UserManagement Module
    if (this.$route.params.exhibitorId == undefined) {
      this.$router.push({ name: "exhibitor" }).catch(() => {});
    } else {
    if (!moduleExhibitorManagement.isRegistered) {
      this.$store.registerModule("exhibitorManagement", moduleExhibitorManagement);
      moduleExhibitorManagement.isRegistered = true;
    }
    this.fetchExhibitorSettings();
    this.fetch_exhibitor_data(this.$route.params.exhibitorId);
    }
  }
};
</script>